import {AUTH_ERROR_CODES} from "helpers/errorCodes";
import {triggerToast} from "helpers";

export default (error) => {
  const errorCode = error?.response?.data?.errorCode;
  const errorMessage = error?.response?.data?.message;

  switch (errorCode) {
    case AUTH_ERROR_CODES.API_KEY_REQUIRED:
    case AUTH_ERROR_CODES.API_KEY_EXPIRED:
    case AUTH_ERROR_CODES.INVALID_API_KEY:
      triggerToast("Authentication error. Please try again.", "error");
      break;

    case AUTH_ERROR_CODES.USER_IS_BLOCKED:
      triggerToast("Your account has been blocked. Please contact support.", "error");
      break;

    case AUTH_ERROR_CODES.FIRST_NAME_REQUIRED:
    case AUTH_ERROR_CODES.LAST_NAME_REQUIRED:
      triggerToast("Please provide your full name.", "error");
      break;

    case AUTH_ERROR_CODES.EMAIL_REQUIRED:
      triggerToast("Please enter your email address.", "error");
      break;

    case AUTH_ERROR_CODES.PHONE_REQUIRED:
      triggerToast("Please enter your phone number.", "error");
      break;

    case AUTH_ERROR_CODES.INVALID_EMAIL:
      triggerToast("Please enter a valid email address.", "error");
      break;

    case AUTH_ERROR_CODES.INVALID_PHONE:
      triggerToast("Please enter a valid phone number.", "error");
      break;

    case AUTH_ERROR_CODES.INVALID_REQUEST:
      triggerToast("Invalid request. Please try again.", "error");
      break;

    case AUTH_ERROR_CODES.AGENT_ARCHIVED:
      triggerToast("This account is no longer active.", "error");
      break;

    case AUTH_ERROR_CODES.EMAIL_PHONE_MISMATCH:
      triggerToast("The email and phone number do not match.", "error");
      break;

    case AUTH_ERROR_CODES.PASSWORD_REQUIRED:
      triggerToast("Please enter your password.", "error");
      break;

      //Passing the error message directly from the API, through default.
    // case AUTH_ERROR_CODES.INVALID_CREDENTIALS:
    //   triggerToast("Invalid user.", "error");
    //   break;

    case AUTH_ERROR_CODES.TOKEN_PASSWORD_REQUIRED:
      triggerToast("Token and password are required.", "error");
      break;

    case AUTH_ERROR_CODES.PASSWORD_TOO_SHORT:
      triggerToast("Your password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character (! $ & ( ) * + , - . _ ~)..", "error");
      break;

    case AUTH_ERROR_CODES.INVALID_TOKEN:
      triggerToast("Invalid or expired token. Please try again.", "error");
      break;

    case AUTH_ERROR_CODES.INVALID_CAPTCHA:
      triggerToast("Invalid captcha. Please try again.", "error");
      break;

    case AUTH_ERROR_CODES.UNKNOWN_ERROR:
    default:
      triggerToast(errorMessage || "An unexpected error occurred. Please try again.", "error");
      break;
  }
};
